import { translate } from 'internal/translate'

const translations = {
  en: {
    footer: {
      aBrandOf: 'A brand of',
      contact: 'Contact',
      socialTitle: 'Become our friend',
      languageTitle: 'Languages',
      countriesTitle: 'Countries',
      awardsTitle: 'Distinguished',
      shippingTitle: 'Shipping',
      paymentTitle: 'Payments',
    },
    contactSlug: 'service?section=contact',
    return: {
      ownCostInfo:
        'Returns outside Germany, Switzerland and Italy are at your own expense.',
      createReturn: 'Create return label',
      registerReturn: 'Register return',
      selectAddress: 'Select sender address',
      qrCode: {
        title: 'DHL Return',
        subHeadline: 'Scan the QR code in a DHL store or a packing station.',
        availableUntil: 'QR code valid until {date}',
        saveButton: 'Download QR-Code',
        downloadButton: 'Download returns label',
      },
      batteryHint: {
        headline: 'Products with battery',
        description:
          'I confirm that the batteries are undamaged and inconspicuous.',
        item1:
          'There is no visible damage such as cracks, swelling or tarnishing.',
        item2: 'The batteries are not noticeably heated when switched off.',
        importantHint: 'Important note',
        batteryDamage:
          'If the batteries are damaged, do not return the product to us, but contact our Customer Happiness Team for further action.',
        contactCH: 'Contact Customer Happiness Team',
      },
      packagingHint: {
        headline: 'Packaging instructions',
        description:
          'Please return the product in the original box with the battery warning label.',
      },
      nextSteps: {
        headline: 'Next Steps',
        item1: 'Send us your return within 30 days.',
        item2:
          'Once we have received your parcel, it can take up to a week to process your return.',
        item3:
          'We will refund you the amount using the same payment method that you used for your order.',
      },
    },
    noMessageReceived: {
      title: 'No message received?',
      content: [
        'Check your spam folder',
        'Check the spelling of your email',
        'Try again later',
      ],
    },
    auth: {
      for: 'login for',
      crossLoginHint: 'the same access data applies to every brand account.',
      blocked: {
        title: 'Take a break',
        content:
          'Your account is currently blocked. Please wait {minutes} minutes to log in again.',
        backToLogin: 'Back to login',
      },
      migration: {
        enterEmail: 'Enter your email address:',
        entryOrToRegistration: 'Check your entry or go to registration.',
        toRegistration: 'To registration',
        new: 'From now on with password. We have sent you an email to create a password. <br /> <br /> Look in your mailbox for: <strong>{email}</strong>',
      },
      password: {
        minLength: 'At least 8 characters',
        reset: {
          title: 'Oops! Forgot your password',
          content:
            'No problem! Please enter the email address associated with your customer account. We will send you a link to reset it.',
          button: 'Reset password',
          sent: {
            success: 'We have sent you an email to <strong>{email}</strong>.',
          },
        },
        hide: 'hide',
        show: 'show',
        capsLockWarning: 'caps lock is active!',
        restore: {
          title: 'Create new password',
          createPassword: 'Create password',
          changePassword: 'Change password',
        },
      },
      login: {
        title: 'login',
        loginAttemptsRemaining:
          '<strong>{loginAttemptsRemaining} attempts left</strong> before your account is temporarily locked',
        validation: {
          loginFailed: 'Email or password is incorrect. Please try again.',
        },
      },
      register: {
        title: 'register',
        highlights: {
          list: [
            'Access data applies to every brand account',
            'Easy overview of the orders',
            'Free returns for Germany and Switzerland',
          ],
        },
        privatePolicy: {
          link: '/en/privacy-policy',
          checkbox: ['I have read the', 'privacy policy', '(mandatory field)'],
        },
        newsletter: {
          checkbox: 'Subscribe to the newsletter.',
          info: [
            'I agree that FOND OF GmbH informs me about promotions & competitions, product news as well as current trends of their brands via e-mail and allows me to rate products.',
            'I assure that I am at least 16 years old. A revocation or an unsubscription from the newsletter is possible at any time via a link in the newsletter or via a message to',
            'Please also note our',
            'privacy policy',
          ],
        },
        alreadyRegistered: {
          alert:
            'An account already exists with our brands. Please log in with the same access data or use a different email address.',
          toLogin: 'Log in with email address',
          forgotPassword: 'Forgot password',
        },
      },
    },
    addToCart: 'Add to Cart',
    newsletter: {
      subscribe: 'Subscribe',
      alreadySubscribedTitle: 'You have already subscribed to our newsletter',
      successMailSentTitle: 'Please confirm your registration',
      alreadySubscribed:
        'Your e-mail address is on our mailing list and you will hear from us soon!',
      successMailSent:
        'We have just sent you an e-mail - please open it and confirm your registration via the link.',
      noteSpam: 'Also check your spam folder if you cannot find an e-mail.',
    },
    customerSatisfaction: {
      title: 'Rate us!',
      description:
        'How satisfied are you with the shopping experience in our online shop?',
      feedbackPlaceholder: 'Please give us further feedback on your purchase.',
      privacyPolicy:
        'Here you can read our <a class="text-primary" target="_blank" href="{link}">privacy policy</a>.',
      submit: 'Submit rating',
      pleaseProvideRating: 'Please choose an emoji',
      submittedTitle: 'Thank you very much!',
      submittedText:
        'Thank you for taking the time to give us feedback so that we can further improve our online shop with your help! We would be happy if you shared your experiences publicly on Google with other users: <a class="text-primary" target="_blank" href="{link}">Rate now publicly on Google</a>.',
      googleRatingUrl: 'http://bit.ly/satch-google-bewertung',
    },
    cart: {
      title: 'My Cart',
      empty: 'Your shopping cart is empty',
      article: 'Article',
      articleAdded: 'Article added',
      articleAddedLong: 'Item added to cart',
      style: 'Style',
      toCart: 'To cart',
      cartItems: {
        promotionalInfo: 'Note for discount campaign',
        attributes: {
          size: 'Size',
          style: 'Style',
          value: 'Value',
          quantity: 'Quantity',
        },
      },
    },
    apply: 'Apply',
    next: 'Next',
    new: 'New',
    more: 'more',
    less: 'less',
    discover_now: 'Discover now',
    to_product: 'To product',
    email: 'E-mail',
    password: 'Password',
    close: 'close',
    back: 'back',
    show_less: 'show less',
    urls: {
      privatePolicy: 'privacy-policy',
    },
    validation: {
      formErrors: 'The form contains errors',
      addToCart: 'An error occurred while adding the product',
      requiredField: 'Required field',
      error: {
        requiredField: 'Please fill in mandatory field.',
      },
    },
    product: {
      addToCart: 'add to cart',
      addToCartAtWishlist: 'Cart',
      atCart: 'At cart',
      comingSoon: 'coming soon',
      availableAt: 'available at',
      availableAgainAt: 'available at',
      soldOut: 'sold out',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'voucher',
    },
    navigation: {
      customer_menu: {
        logout: {
          my_account: 'My Account',
          my_orders: 'My Orders',
          logout: 'Logout',
          backToShop: 'Back to the shop',
        },
        login: {
          header: 'Login here at satch.',
          content:
            'Enter your email address and we will send you your login link:',
          button: 'Request login link',
          footer: 'New here?',
          register: 'Register now',
          privacy: 'privacy policy',
          info: [
            'By pressing the button, I consent to the processing of my data in accordance with the',
            '.',
          ],
        },
        loginSuccess: {
          header: 'Your email is on its way to you.',
          content: [
            'We have sent you the email to',
            '. Check your email inbox and click the link to login. Also check your spam folder.',
            "Don't get an email? Then there is no account with us under this email. You can register",
          ],
          register: 'register here now',
        },
        registerSuccess: {
          header: 'Your email is on its way to you.',
          content: [
            'We have sent you the email to',
            '. Check your email inbox and complete the registration using the link in the email.',
          ],
        },
        validation: {
          email: {
            required: 'Email must contain a valid email address',
          },
        },
        register: {
          header: 'Become part of the satch community.',
          content: [
            'Become a member and secure your advantages:',
            'Enter your email address and we will send you a link to register:',
          ],
          list: [
            'Overview of your orders',
            'Always see directly what status your order is in',
            'Create return or complaint directly from your order',
          ],
          info: [
            'By pressing the button, I consent to the processing of my data to create a customer account in accordance with the',
            '.',
          ],
          privacy: 'Privacy policy',
          button: 'Register now',
          footer: 'You have an account?',
          login: 'Log in here',
        },
        registerConfirm: {
          header: 'Hello {name}',
          content: [
            'You are almost there. To complete the registration you must agree to our privacy policy.',
          ],
          privacy: ['I have taken note of the', '.'],
          newsletter: {
            title: 'Subscribe to the newsletter',
            content:
              'I agree that FOND OF GmbH informs me about promotions & competitions, product news as well as current trends of their brands via e-mail and allows me to rate products.',
            more: 'more',
            moreContent: [
              'I assure that I am at least 16 years old. A revocation or an unsubscription from the newsletter is possible at any time via a link in the newsletter or via a message to',
              '. Please also note our',
            ],
            less: 'less',
            policy: 'Privacy policy',
            submit: 'Complete registration',
            cancel: 'Cancel registration',
          },
        },
        registerConfirmSuccess: {
          header: 'Login link sent',
          content: [
            'We have sent you an email to',
            '. Check your email inbox to log in to the customer account. Also check your spam folder.',
          ],
          button: 'All right',
        },
        customerAccount: 'Customer account',
      },
      defaultErrorMessage: 'Something went wrong',
    },
    filter: {
      DEFAULT: 'Filter',
      title: 'Filter',
      'price-DEFAULT-EUR-GROSS_MODE': 'Price',
      edition: 'Special Edition',
      resetAll: 'Reset all',
    },
    price: {
      DEFAULT: 'Price',
    },
    price_asc: 'Price ascending',
    price_desc: 'Price descending',
    noResults: 'No matches found',
    apparel: 'Apparel',
    book: 'Book',
    kletties: 'Kletties',
    koffer: 'Luggage',
    furniture: 'Furniture',
    move: 'Vehicle',
    backpack: 'Backback',
    shoes: 'Shoe',
    accessories: 'Accessories',
    voucher: 'Voucher',
    video: {
      playVideo: 'Play video',
      pauseVideo: 'Pause video',
      play: 'Play',
      pause: 'Pause',
    },
    productDetail: {
      zoomHint: 'Double tap to enlarge',
      imageHint: 'Product images may vary from the original',
    },
    linkTags: '/en/accessories/tags',
    wishlist: {
      wishlist: 'Wishlist',
      myWishlist: 'My wishlist',
      addProduct: 'The product has been added to the wishlist',
      deleteProduct: 'The product has been removed from your wishlist',
      noItems:
        "There's still plenty of room for your style and your wishes! Be inspired by our product selection and fill your wish list with your favorite products.",
      loginRequired:
        '[Sign in or create a customer account]({link}) to use the wishlist.',
      defaultErrorMessage: 'Something went wrong',
    },
  },
  de: {
    footer: {
      aBrandOf: 'Eine Marke von',
      contact: 'Kontakt',
      socialTitle: 'Werde unser Freund',
      languageTitle: 'Sprachen',
      countriesTitle: 'Länder',
      awardsTitle: 'Ausgezeichnet',
      shippingTitle: 'Versand',
      paymentTitle: 'Zahlung',
    },
    contactSlug: 'service?section=contact',
    return: {
      ownCostInfo:
        'Retouren außerhalb von Deutschland, Schweiz und Italien erfolgen auf eigene Kosten.',
      createReturn: 'Retourenlabel erstellen',
      registerReturn: 'Retoure anmelden',
      selectAddress: 'Absender-Adresse auswählen',
      qrCode: {
        title: 'DHL Retoure',
        subHeadline: 'Scanne den QR Code in eine DHL Filiale oder Packstation.',
        availableUntil: 'QR Code gültig bis {date}',
        saveButton: 'QR-Code herunterladen',
        downloadButton: 'Retourenlabel herunterladen',
      },
      batteryHint: {
        headline: 'Produkte mit Batterie',
        description:
          'Ich bestätige, dass die Batterien unbeschädigt und unauffällig sind.',
        item1:
          'Es gibt keine sichtbaren Schäden wie Risse, Aufblähungen oder Anlaufstellen.',
        item2:
          'Die Batterien sind im ausgeschalteten Zustand nicht spürbar erwärmt.',
        importantHint: 'Wichtiger Hinweis',
        batteryDamage:
          'Falls die Batterien beschädigt sind, schicke das Produkt nicht an uns zurück, sondern kontaktiere unser Customer-Happiness-Team für das weitere Vorgehen.',
        contactCH: 'Kontakt Customer-Happiness-Team',
      },
      packagingHint: {
        headline: 'Verpackungshinweis',
        description:
          'Bitte retourniere das Produkt im Originalkarton mit dem Batterie-Warnhinweis.',
      },
      nextSteps: {
        headline: 'Nächste Schritte',
        item1: 'Schicke uns deine Retoure innerhalb von 30 Tagen zu.',
        item2:
          'Sobald dein Paket bei uns eingetroffen ist, kann die Bearbeitungszeit der Retoure vorrausichtlich bis zu einer Woche dauern.',
        item3:
          'Wir erstatten dir den Betrag mit der selben Zahlungsart zurück, die du in deiner Bestellung genutzt hast.',
      },
    },
    noMessageReceived: {
      title: 'Keine Nachricht erhalten?',
      content: [
        'Überprüfe deinen Spam-Ordner',
        'Überprüfe die Schreibweise deiner E-Mail',
        'Versuche es später noch einmal',
      ],
    },
    auth: {
      for: 'login für',
      crossLoginHint:
        'es gelten die selben Zugangsdaten für jedes Marken-Konto.',
      blocked: {
        title: 'Mach mal eine Pause',
        content:
          'Dein Konto ist aktuell gesperrt. Bitte warte {minutes} Minuten ab, um dich erneut anzumelden.',
        backToLogin: 'Zurück zur Anmeldung',
      },
      migration: {
        enterEmail: 'Gib deine E-Mail Adresse ein:',
        entryOrToRegistration:
          'Überprüfe deine Eingabe oder gehe zur Registrierung.',
        toRegistration: 'Zur Registrierung',
        new: 'Ab jetzt mit Passwort. Um dir ein Passwort zu erstellen, haben wir dir eine E-Mail geschickt. <br /> <br /> Siehe in deinem Postfach nach: <strong>{email}</strong>',
      },
      password: {
        minLength: 'Mindestens 8 Zeichen',
        reset: {
          title: 'Passwort vergessen',
          content:
            'Kein Problem! Bitte gib die E-Mail-Addresse ein, die mit deinem Kundenkonto verknüpft ist. Wir senden dir einen Link zum Zurücksetzen.',
          button: 'Passwort zurücksetzen',
          sent: {
            success:
              'Wir haben dir eine E-Mail an <strong>{email}</strong> gesendet.',
          },
        },
        hide: 'verbergen',
        show: 'anzeigen',
        capsLockWarning: 'Großbuchstaben sind aktiviert!',
        restore: {
          title: 'Neues Passwort erstellen',
          createPassword: 'Passwort erstellen',
          changePassword: 'Passwort ändern',
        },
      },
      login: {
        title: 'anmelden',
        loginAttemptsRemaining:
          '<strong>Noch {loginAttemptsRemaining} Versuche</strong> bevor dein Konto vorübergehend gesperrt wird',
        validation: {
          loginFailed:
            'E-Mail oder Passwort sind falsch. Bitte versuche es erneut.',
        },
      },
      register: {
        title: 'registrieren',
        highlights: {
          list: [
            'Zugangsdaten gelten für jedes Marken-Konto',
            'Einfache Übersicht über die Bestellungen',
            'Kostenlose Retoure für Deutschland und Schweiz',
          ],
        },
        privatePolicy: {
          link: '/de/datenschutz',
          checkbox: [
            'Ich habe die',
            'Datenschutzerklärung',
            'zur Kenntnis genommen. (Pflichtfeld)',
          ],
        },
        newsletter: {
          checkbox: 'In den Newsletter eintragen.',
          info: [
            'Ich willge ein, dass die FOND OF GmbH mich über Aktionen & Gewinnspiele, Produktneuheiten sowie aktuelle Trends ihrer Marken per E-Mail informiert und mir ermöglicht, Produkte zu bewerten.',
            'Ich versichere, dass ich mindestens 16 Jahre alt bin. Ein Widerruf bzw. eine Abmeldung des Newsletters ist jederzeit über einen Link im Newsletter oder über eine Nachricht an',
            'möglich. Bitte beachte auch unsere',
            'Datenschutzerklärung',
          ],
        },
        alreadyRegistered: {
          alert:
            'Es existiert bereits ein Konto bei unseren Marken. Bitte melde dich mit den selben Zugangsdaten an oder verwende eine andere E-Mail Adresse.',
          toLogin: 'Mit E-Mail Adresse anmelden',
          forgotPassword: 'Passwort vergessen',
        },
      },
    },
    addToCart: 'In den Warenkorb',
    newsletter: {
      subscribe: 'Anmelden',
      alreadySubscribedTitle: 'Du hast unseren Newsletter bereits abonniert',
      successMailSentTitle: 'Bitte bestätige deine Anmeldung',
      alreadySubscribed:
        'Deine E-Mail-Adresse ist in unserem Verteiler hinterlegt und du wirst bald von uns hören!',
      successMailSent:
        'Wir haben dir gerade eine E-Mail geschickt – bitte öffne sie und bestätige deine Anmeldung über den Link.',
      noteSpam:
        'Schau auch im Spam-Ordner nach, falls du keine E-Mail findest.',
    },
    customerSatisfaction: {
      title: 'Bewerte uns!',
      description:
        'Wie zufrieden bist du mit deiner Erfahrung bei uns im Shop?',
      feedbackPlaceholder: 'Gib uns gerne weiteres Feedback zu deinem Einkauf.',
      privacyPolicy:
        'Hier kannst du unsere <a class="text-primary" target="_blank" href="{link}">Datenschutzerklärung</a> lesen.',
      submit: 'Bewertung abschicken',
      pleaseProvideRating: 'Bitte wähle einen Emoji aus',
      submittedTitle: 'Vielen Dank!',
      submittedText:
        'Danke, dass du dir die Zeit genommen hast, uns Feedback zu geben, sodass wir unseren Onlineshop durch deine Mithilfe weiter verbessern können! Wir freuen uns, wenn du deine Erfahrungen auch öffentlich bei Google mit anderen Nutzern teilst: <a class="text-primary" target="_blank" href="{link}">Jetzt bei Google öffentlich bewerten</a>.',
      googleRatingUrl: 'http://bit.ly/satch-google-bewertung',
    },
    cart: {
      title: 'Mein Warenkorb',
      empty: 'Dein Warenkorb ist leer',
      article: 'Artikel',
      articleAdded: 'Artikel hinzugefügt',
      articleAddedLong: 'Artikel zum Warenkorb hinzugefügt',
      style: 'Style',
      toCart: 'Zum Warenkorb',
      cartItems: {
        promotionalInfo: 'Hinweis für Rabattaktion',
        attributes: {
          size: 'Größe',
          style: 'Style',
          value: 'Wert',
          quantity: 'Anzahl',
        },
      },
    },
    apply: 'Speichern',
    next: 'Weiter',
    new: 'Neu',
    more: 'mehr',
    less: 'weniger',
    discover_now: 'Jetzt entdecken',
    to_product: 'Zum Produkt',
    close: 'schließen',
    back: 'zurück',
    show_less: 'weniger anzeigen',
    email: 'E-Mail',
    password: 'Passwort',
    urls: {
      privatePolicy: 'datenschutz',
    },
    validation: {
      formErrors: 'Das Formular enthält Fehler',
      addToCart: 'Beim Hinzufügen des Produkts ist ein Fehler aufgetreten',
      requiredField: 'Pflichtfeld',
      error: {
        requiredField: 'Bitte Pflichtfeld ausfüllen',
      },
    },
    product: {
      addToCart: 'hinzufügen',
      addToCartAtWishlist: 'Warenkorb',
      atCart: 'Im Warenkorb',
      comingSoon: 'coming soon',
      availableAt: 'verfügbar ab',
      availableAgainAt: 'wieder verfügbar ab',
      soldOut: 'ausverkauft',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Gutschein',
    },
    navigation: {
      customer_menu: {
        logout: {
          my_account: 'Mein Konto',
          my_orders: 'Meine Bestellungen',
          logout: 'Abmelden',
          backToShop: 'Zurück zum Shop',
        },
        login: {
          header: 'Melde dich hier bei satch an.',
          content:
            'Gib deine E-Mail-Adresse ein und wir senden dir deinen Anmelde-Link zu:',
          button: 'Anmelde-Link anfordern',
          footer: 'Neu hier?',
          register: 'Jetzt registrieren',
          privacy: 'Datenschutzerklärung',
          info: [
            'Mit Betätigung des Buttons willige ich in die Verarbeitung meiner Daten gemäß der',
            'ein.',
          ],
        },
        loginSuccess: {
          header: 'Deine E-Mail ist auf dem Weg zu dir.',
          content: [
            'Wir haben dir die E-Mail an',
            'gesendet. Schaue in deinem E-Mail Postfach nach und klicke den Link zur Anmeldung an. Schaue auch in deinem Spam Ordner nach.',
            'Keine E-Mail bekommen? Dann existiert unter dieser E-Mail kein Konto bei uns. Du kannst dich',
          ],
          register: 'jetzt hier registrieren',
        },
        registerSuccess: {
          header: 'Deine E-Mail ist auf dem Weg zu dir.',
          content: [
            'Wir haben dir die E-Mail an',
            'gesendet. Schaue in deinem E-Mail Postfach nach und schließe die Registrierung über den Link in der E-Mail ab.',
          ],
        },
        validation: {
          email: {
            required: 'E-Mail muss eine gültige E-Mail-Adresse enthalten',
          },
        },
        register: {
          header: 'Werde Teil der satch Community.',
          content: [
            'Werde Mitglied und sichere dir deine Vorteile:',
            'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zur Registrierung zu:',
          ],
          list: [
            'Übersicht deiner Bestellungen',
            'Immer direkt sehen, in welchem Status sich deine Bestellung befindet',
            'Erstelle Retoure oder Reklamation direkt aus deiner Bestellung heraus',
          ],
          info: [
            'Mit Betätigung des Buttons willige ich in die Verarbeitung meiner Daten zur Erstellung eines Kundenkontos gemäß der',
            'ein.',
          ],
          privacy: 'Datenschutzerklärung',
          button: 'Jetzt registrieren',
          footer: 'Du hast ein Konto?',
          login: 'Hier anmelden',
        },
        registerConfirm: {
          header: 'Hallo {name}',
          content: [
            'Du hast es fast geschafft. Um die Registrierung abzuschließen, musst du unserer Datenschutzerklärung zustimmen.',
          ],
          privacy: ['Ich habe die', 'zur Kenntnis genommen.'],
          newsletter: {
            title: 'In den Newsletter eintragen',
            content:
              'Ich willige ein, dass die FOND OF GmbH mich über Aktionen & Gewinnspiele, Produktneuheiten sowie aktuelle Trends ihrer Marken per E-Mail informiert und mir ermöglicht, Produkte zu bewerten.',
            more: 'mehr',
            moreContent: [
              'Ich versichere, dass ich mindestens 16 Jahre alt bin. Ein Widerruf bzw. eine Abmeldung des Newsletters ist jederzeit über einen Link im Newsletter oder über eine Nachricht an',
              'möglich. Bitte beachte auch unsere',
            ],
            less: 'weniger',
            policy: 'Datenschutzerklärung',
            submit: 'Registrierung abschließen',
            cancel: 'Registrierung abbrechen',
          },
        },
        registerConfirmSuccess: {
          header: 'Anmelde-Link versendet',
          content: [
            'Wir haben dir eine E-Mail an',
            'gesendet. Schau in deinem E-Mail Postfach nach, um dich im Kundenkonto anzumelden. Schau auch in deinem Spam Ordner nach.',
          ],
          button: 'Alles Klar',
        },
        customerAccount: 'Mein Konto',
      },
    },
    filter: {
      DEFAULT: 'Filter',
      title: 'Filtern',
      style: 'Tier',
      'price-DEFAULT-EUR-GROSS_MODE': 'Preis',
      edition: 'Special Edition',
      resetAll: 'Alles zurücksetzen',
    },
    price: {
      DEFAULT: 'Preis',
    },
    price_asc: 'Preis aufsteigend',
    price_desc: 'Preis absteigend',
    noResults: 'Keine Treffer gefunden',
    apparel: 'Bekleidung',
    book: 'Buch',
    kletties: 'Klettier',
    koffer: 'Koffer',
    furniture: 'Möbel',
    move: 'Move/Fahrzeuge',
    backpack: 'Rucksack',
    shoes: 'Schuhe',
    accessories: 'Zubehör',
    voucher: 'Gutschein',
    video: {
      playVideo: 'Video abspielen',
      pauseVideo: 'Video anhalten',
      play: 'Abspielen',
      pause: 'Pause',
    },
    productDetail: {
      zoomHint: 'Zum Zoomen doppelt tippen',
      imageHint: 'Produktbilder können vom Original abweichen',
    },
    linkTags: '/de/zubehoer/tags',
    wishlist: {
      wishlist: 'Wunschliste',
      myWishlist: 'Meine Wunschliste',
      addProduct: 'Das Produkt wurde zur Wunschliste hinzugefügt',
      deleteProduct: 'Das Produkt wurde von deiner Wunschliste entfernt',
      noItems:
        'Hier ist noch ganz viel Platz für deinen Style und deine Wünsche! Lass dich von unserem Sortiment inspirieren und fülle deine Wunschliste mit Lieblingsprodukten.',
      loginRequired:
        '[Melde dich an oder erstelle ein Kundenkonto]({link}), um die Wunschliste nutzen zu können.',
      defaultErrorMessage: 'Es ist etwas schief gelaufen',
    },
  },
  it: {
    footer: {
      aBrandOf: 'Un marchio di',
      contact: 'Contattateci',
      socialTitle: 'Diventa nostro amico',
      languageTitle: 'Linguas',
      countriesTitle: 'Paesi',
      awardsTitle: 'Eccellente',
      shippingTitle: 'Shipping',
      paymentTitle: 'Pagamento',
    },
    contactSlug: 'servizi?section=contact',
    return: {
      ownCostInfo:
        "Le restituzioni al di fuori della Germania, della Svizzera e dell'Italia sono a carico del cliente.",
      createReturn: 'Crea etichetta di reso',
      registerReturn: 'Registra reso',
      selectAddress: 'Seleziona indirizzo del mittente',
      qrCode: {
        title: 'Restituzione DHL',
        subHeadline:
          'Scansionate il codice QR in un negozio DHL o in una Packstation.',
        availableUntil: 'Codice QR valido fino a {date}',
        saveButton: 'Scaricare il codice QR',
        downloadButton: "Scarica l'etichetta di reso",
      },
      batteryHint: {
        headline: 'Prodotti con batteria',
        description: 'Confermo che le batterie sono integre e poco visibili.',
        item1:
          'Non ci sono danni visibili come crepe, rigonfiamenti o appannamenti.',
        item2:
          'Le batterie non si riscaldano in modo evidente quando sono spente.',
        importantHint: 'Nota importante',
        batteryDamage:
          'Se le batterie sono danneggiate, non restituire il prodotto a noi, ma contattare il nostro Customer Happiness Team per ulteriori azioni.',
        contactCH: 'Contattare il team Felicità del cliente',
      },
      packagingHint: {
        headline: "Istruzioni per l'imballaggio",
        description:
          "Si prega di restituire il prodotto nella scatola originale con l'etichetta di avvertenza della batteria.",
      },
      nextSteps: {
        headline: 'Le prossime tappe',
        item1: 'Inviateci il vostro reso entro 30 giorni.',
        item2:
          "Una volta ricevuto il pacco, l'elaborazione del reso può richiedere fino a una settimana.",
        item3:
          "Vi rimborseremo l'importo utilizzando lo stesso metodo di pagamento che avete usato per l'ordine.",
      },
    },
    noMessageReceived: {
      title: 'Nessun messaggio ricevuto?',
      content: [
        'Controlla la cartella spam',
        "Controlla la correttezza dell'indirizzo e-mail",
        'Riprova più tardi',
      ],
    },
    auth: {
      for: 'login per',
      crossLoginHint:
        'le stesse credenziali di accesso valgono per ogni account di marca.',
      blocked: {
        title: 'Fai una pausa',
        content:
          'Il tuo account è attualmente bloccato. Attendere {minutes} minuti per accedere nuovamente.',
        backToLogin: 'Torna al login',
      },
      migration: {
        enterEmail: 'Inserisci il tuo indirizzo e-mail:',
        entryOrToRegistration:
          'Controlla la tua voce o passa alla registrazione.',
        toRegistration: 'Per registrarti',
        new: "Da ora con password. Ti abbiamo inviato un'e-mail per creare una password. <br /> <br /> Guarda nella tua casella di posta: <strong>{email}</strong>",
      },
      password: {
        minLength: 'Almeno 8 caratteri',
        reset: {
          title: 'Oops! Password dimenticata',
          content:
            "Nessun problema! Inserisci l'indirizzo e-mail associato al tuo account cliente. Ti invieremo un link per reimpostare la password.",
          button: 'Reimposta password',
          sent: {
            success: "Ti abbiamo inviato un'e-mail a <strong>{email}</strong>.",
          },
        },
        hide: 'nascondi',
        show: 'mostra',
        capsLockWarning: 'Il tasto maiuscole è attivo!',
        restore: {
          title: 'Crea una nuova password',
          createPassword: 'Crea una password',
          changePassword: 'Cambia password',
        },
      },
      login: {
        title: 'accedi',
        loginAttemptsRemaining:
          'Ancora <strong>{loginAttemptsRemaining} tentativi</strong> prima che il tuo account venga temporaneamente bloccato',
        validation: {
          loginFailed:
            "L'e-mail o la password sono errate. Si prega di riprovare.",
        },
      },
      register: {
        title: 'registrati',
        highlights: {
          list: [
            'Le credenziali di accesso valgono per ogni account del marchio',
            'Facile visualizzazione degli ordini',
            'Restituzione gratuita per Germania e Svizzera',
          ],
        },
        privatePolicy: {
          link: '/it/privacy-policy',
          checkbox: [
            'Ho letto l',
            'informativa sulla privacy',
            '(campo obbligatorio)',
          ],
        },
        newsletter: {
          checkbox: 'Iscriviti alla newsletter.',
          info: [
            'Accetto che FOND OF GmbH mi informi su promozioni e concorsi, novità sui prodotti e tendenze attuali dei loro marchi via e-mail e',
            'mi permetta di valutare i prodotti.',
            'Garantisco di avere almeno 16 anni. Una revoca o una disiscrizione alla newsletter è possibile in qualsiasi momento tramite un link nella newsletter o tramite un messaggio a',
            'Si prega di notare anche la nostra',
          ],
        },
        alreadyRegistered: {
          alert:
            'Esiste già un account con i nostri marchi. Accedi con le stesse credenziali di accesso o utilizza un altro indirizzo e-mail.',
          toLogin: "Accedi con l'indirizzo e-mail",
          forgotPassword: 'Password dimenticata',
        },
      },
    },
    addToCart: 'Aggiungi al carrello',
    newsletter: {
      subscribe: 'Registrati',
      alreadySubscribedTitle: 'Siete già iscritti alla nostra newsletter',
      successMailSentTitle: 'Confermare la registrazione',
      alreadySubscribed:
        'Il vostro indirizzo e-mail è stato inserito nella nostra mailing list e avrete presto nostre notizie!',
      successMailSent:
        "Le abbiamo appena inviato un'e-mail - la preghiamo di aprirla e di confermare la sua iscrizione tramite il link.",
      noteSpam:
        "Controllate anche la cartella spam se non riuscite a trovare un'e-mail.",
    },
    customerSatisfaction: {
      title: 'Ancora una domanda.',
      description:
        'Quanto sei soddisfatto/a della tua esperienza di acquisto nel nostro negozio online?',
      feedbackPlaceholder:
        'Ti preghiamo di darci un ulteriore feedback sul tuo acquisto.',
      privacyPolicy:
        'Fai clic qui per leggere la nostra <a class="text-primary" target="_blank" href="{link}">Informativa sulla privacy</a>.',
      submit: 'Lascia una recensione',
      pleaseProvideRating: "Selezionare un'emoji",
      submittedTitle: 'Grazie!',
      submittedText:
        'Grazie per aver dedicato del tempo a fornirci un feedback. Con il tuo aiuto possiamo continuare a migliorare il nostro negozio online. Saremmo lieti se condividessi pubblicamente le tue esperienze con gli altri utenti su Google: <a class="text-primary" target="_blank" href="{link}">Scrivi ora una recensione su Google.</a>',
      googleRatingUrl: 'https://bit.ly/satch-google-bewertung',
    },
    cart: {
      empty: 'Il carrello è vuoto',
      title: 'Carello',
      article: 'Prodotto',
      articleAdded: 'Articolo aggiunto',
      articleAddedLong: 'Articolo aggiunto al carrello',
      style: 'Stile',
      toCart: 'Vai al carrello',
      cartItems: {
        promotionalInfo: 'Nota per la campagna di sconti',
        attributes: {
          size: 'Dimensione',
          style: 'Stile',
          value: 'Valore',
          quantity: 'Quantità',
        },
      },
    },
    discover_now: 'Scopri ora',
    to_product: 'Al prodotto',
    apply: 'Applicare',
    next: 'Avanti',
    more: 'di più',
    less: 'di meno',
    email: 'E-mail',
    password: 'Password',
    urls: {
      privatePolicy: 'privacy-policy',
    },

    validation: {
      formErrors: 'Il modulo contiene errori',
      addToCart: "Si è verificato un errore durante l'aggiunta del prodotto",
      requiredField: 'Campo obbligatorio',
      error: {
        requiredField: 'Compilare il campo obbligatorio.',
      },
    },
    back: 'Indietro',
    new: 'Nuovo',
    menu: 'Menu',
    close: 'Chiudere',
    crossSelling: {
      moreFromCreators: 'Altro dai produttori di Affenzahn',
    },
    product: {
      addToCart: 'Aggiungi',
      addToCartAtWishlist: 'Carrello',
      atCart: 'Nel carrello',
      comingSoon: 'prossimamente',
      availableAt: 'Disponibile da',
      availableAgainAt: 'Di nuovo disponibile dal',
      soldOut: 'esaurito',
      voucher: 'Buoni',

      new: 'new',
      sale: 'sale',
      free: 'free',
    },
    navigation: {
      browseAll: 'Cerca tutti',
      defaultErrorMessage: 'Qualcosa è andato storto',
      quickLinks: 'Quick Links',
      customer_menu: {
        myAccount: 'Il mio account',
        logout: {
          my_account: 'Il mio account',
          my_orders: 'I miei ordini',
          logout: 'Disconnessione',
          backToShop: 'Torna al negozio',
        },
        login: {
          header: 'Effettuate il login qui su satch.',
          content:
            "Inserisci l'indirizzo e-mail per ricevere il link di accesso",
          button: 'Richiedi il link di accesso',
          footer: 'Hai già un account?',
          privacy: 'privacy',
          info: [
            "Facendo clic sul pulsante, acconsento al trattamento dei miei dati in conformità con l'informativa sulla ",
            '.',
          ],
          register: 'Accedi ora',
          close: 'Chiudere',
        },
        loginSuccess: {
          header: "A breve riceverai un'e-mail.",
          content: [
            "Ti abbiamo inviato un'e-mail all'indirizzo",
            'Controlla la tua casella di posta e fai clic sul link per registrarti. Controlla anche la cartella spam.',
            "Non hai ricevuto l'e-mail? In tal caso, vuol dire che non esiste un account associato al tuo indirizzo e-mail.",
          ],
          register: 'Puoi registrarti qui.',
        },
        registerSuccess: {
          header: "A breve riceverai un'e-mail.",
          content: [
            "Ti abbiamo inviato un'e-mail all'indirizzo .",
            "Controlla la tua casella di posta e completa la registrazione mediante il link contenuto nell'e-mail.",
          ],
        },
        validation: {
          email: {
            required: 'Inserisci un indirizzo e-mail validoL',
          },
        },
        register: {
          header: 'Entra a far parte della community satch.',
          content: [
            'Diventate membri e assicuratevi i vostri vantaggi:',
            'Inserite il vostro indirizzo e-mail e vi invieremo un link per la registrazione:',
          ],
          list: [
            'Panoramica degli ordini',
            'Vedere sempre direttamente in quale stato si trova il vostro ordine',
            "Creare un reso o un reclamo direttamente dall'ordine",
          ],
          info: [
            'Premendo il pulsante, acconsento al trattamento dei miei dati per la creazione di un account cliente in conformità con la',
            '.',
          ],
          privacy: 'Informativa sulla privacy',
          button: 'Registrati subito',
          footer: 'Hai già un account? Iscriviti qui',
          login: 'Accedi qui',
        },
        registerConfirm: {
          header: 'Ciao {name}',
          content: [
            'Hai quasi finito. Per completare la registrazione, devi accettare la nostra Informativa sulla privacy.',
          ],
          privacy: [
            "Ho preso nota dell'Informativa sulla .",
            '(Campo obbligatorio)',
          ],
          newsletter: {
            title: 'Inserisci nella newsletter',
            content:
              'Accetto che FOND OF GmbH mi informi via e-mail su promozioni e giochi a premi, novità sui prodotti e tendenze attuali dei suoi marchi e mi consenta di valutare i prodotti.',
            more: 'per saperne di più',
            moreContent: [
              'Assicuro di avere almeno 16 anni. La revoca o la cancellazione dalla newsletter è possibile in qualsiasi momento tramite un link nella newsletter o tramite un messaggio a ',
              '. Si prega di notare anche la nostra',
            ],
            less: 'meno',
            policy: 'Informativa sulla privacy',
            submit: 'Completare la registrazionen',
            cancel: 'Annullamento della registrazione',
          },
        },
        registerConfirmSuccess: {
          header: 'Ti abbiamo inviato il link di registrazione',
          content: [
            "Ti abbiamo inviato un'e-mail all'indirizzo ",
            ". Controlla la tua casella di posta per accedere all'account cliente. Controlla anche la cartella spam.",
          ],
          button: 'Tutto a posto',
        },
        customerAccount: 'Accedi',
      },
    },
    filter: {
      DEFAULT: 'Filtro',
      title: 'Filtro',
      'price-DEFAULT-EUR-GROSS_MODE': 'Prezzo',
      edition: 'Special Edition',
      resetAll: 'Resetta tutto',
    },
    price: {
      DEFAULT: 'prezzo',
    },
    price_asc: 'Prezzo crescente',
    price_desc: 'Prezzo decrescente',
    noResults: 'Nessuna corrispondenza trovata',
    apparel: 'Abbigliamento',
    book: 'Libro',
    kletties: 'Kletties',
    koffer: 'Kuffert',
    furniture: 'Mobili',
    move: 'Veicoli',
    backpack: 'Zaino',
    shoes: 'Scarpa',
    accessories: 'Accessori',
    voucher: 'Buono',
    video: {
      playVideo: 'Play video',
      pauseVideo: 'Pause video',
      play: 'Play',
      pause: 'Pausa',
    },
    productDetail: {
      zoomHint: 'Tocca due volte per ingrandire',
      imageHint: "Le immagini dei prodotti possono differire dall'originale",
    },
    linkTags: '/it/accessori/tags',
    wishlist: {
      wishlist: 'Lista dei desideri',
      myWishlist: 'La mia lista dei desideri',
      addProduct: 'Il prodotto è stato aggiunto alla lista dei desideri',
      deleteProduct: 'Il prodotto è stato rimosso dalla tua lista dei desideri',
      noItems:
        "C'è ancora spazio per il vostro stile e i vostri desideri! Lasciatevi ispirare dalla nostra gamma e riempite la vostra lista dei desideri con i vostri prodotti preferiti.",
      loginRequired:
        '[Accedi o crea un account cliente]({link}) per utilizzare la lista dei desideri.',
      defaultErrorMessage: 'Qualcosa è andato storto',
    },
  },
  es: {
    footer: {
      aBrandOf: 'Una marca de',
      contact: 'Contacto',
      socialTitle: 'Hazte amigo nuestro',
      languageTitle: 'Idiomas',
      countriesTitle: 'Países',
      awardsTitle: 'Premios',
      shippingTitle: 'Envío',
      paymentTitle: 'Método de pago',
    },
    contactSlug: 'service?section=contact',
    return: {
      ownCostInfo:
        'Las devoluciones fuera de Alemania, Suiza e Italia corren por tu cuenta',
      createReturn: 'Crear etiqueta de devolución',
      registerReturn: 'Registrar devolución',
      selectAddress: 'Selecciona la dirección del remitente',
      qrCode: {
        title: 'Devolución DHL',
        subHeadline:
          'Escanee el código QR en una tienda DHL o en una estación de embalaje',
        availableUntil: 'Código QR válido hasta {date}',
        saveButton: 'Descargar código QR',
        downloadButton: 'Descargar etiqueta de devolución',
      },
      batteryHint: {
        headline: 'Productos con batería',
        description: 'Confirmo que las pilas no están dañadas y son discretas',
        item1: 'No hay daños visibles como grietas, hinchazón o deslustre',
        item2:
          'Las pilas no se calientan de forma perceptible cuando están apagadas.',
        importantHint: 'Nota importante',
        batteryDamage:
          'Si las pilas están dañadas, no nos devuelva el producto, póngase en contacto con nuestro Equipo de Felicidad del Cliente para tomar medidas.',
        contactCH: 'Póngase en contacto con el equipo de atención al cliente',
      },
      packagingHint: {
        headline: 'Instrucciones de embalaje',
        description:
          'Por favor, devuelva el producto en la caja original con la etiqueta de advertencia de la batería',
      },
      nextSteps: {
        headline: 'Pasos siguientes',
        item1: 'Envíenos su devolución en un plazo de 30 días',
        item2:
          'Una vez que hayamos recibido su paquete, podemos tardar hasta una semana en procesar su devolución.',
        item3:
          'Te reembolsaremos el importe utilizando el mismo método de pago que utilizaste para tu pedido.',
      },
    },
    noMessageReceived: {
      title: '¿No has recibido ningún mensaje?',
      content: [
        'Comprueba la carpeta de spam',
        'Comprueba la ortografía de tu correo electrónico',
        'Inténtalo de nuevo más tarde',
      ],
    },
    auth: {
      for: 'inicio de sesión para',
      crossLoginHint:
        'las mismas credenciales de acceso son válidas para cada cuenta de marca.',
      blocked: {
        title: 'Tómate un descanso',
        content:
          'Tu cuenta está bloqueada actualmente. Por favor, espera {minutes} minutos para volver a iniciar sesión.',
        backToLogin: 'Volver al inicio de sesión',
      },
      login: {
        title: 'iniciar sesión',
        loginAttemptsRemaining:
          '<strong>{loginAttemptsRemaining} intentos restantes</strong> antes de que su cuenta se bloquee temporalmente',
        validation: {
          loginFailed:
            'Correo electrónico o contraseña incorrectos. Inténtalo de nuevo.',
        },
      },
      register: {
        title: 'registro',
        highlights: {
          list: [
            'Las credenciales de acceso son válidas para cada cuenta de marca',
            'Vista general de tus pedidos',
            'Devoluciones gratuitas para Alemania y Suiza',
          ],
        },
        privatePolicy: {
          link: '/es/privacy-policy',
          checkbox: [
            'He leído la',
            'política de privacidad',
            '(campo obligatorio)',
          ],
        },
        newsletter: {
          checkbox: 'Suscríbete al boletín.',
          info: [
            'Acepto que FOND OF GmbH me informe sobre promociones y concursos, novedades de productos y tendencias actuales de sus marcas por correo electrónico y',
            'me permita evaluar los productos.',
            'Garantizo tener al menos 16 años. La revocación o la cancelación de la suscripción al boletín es posible en cualquier momento a través de un enlace en el boletín o enviando un mensaje a',
            'También tenga en cuenta nuestra',
          ],
        },
        alreadyRegistered: {
          alert:
            'Ya existe una cuenta con nuestras marcas. Inicia sesión con las mismas credenciales o utiliza otra dirección de correo electrónico.',
          toLogin: 'Iniciar sesión con la dirección de correo electrónico',
          forgotPassword: '¿Olvidaste tu contraseña?',
        },
      },
      migration: {
        enterEmail: 'Introduce tu dirección de correo electrónico:',
        entryOrToRegistration: 'Comprueba tu entrada o ve al registro.',
        toRegistration: 'Para registrarte',
        new: 'A partir de ahora con contraseña. Te hemos enviado un correo electrónico para crear una contraseña. <br /> <br /> Mira en tu bandeja de entrada: <strong>{email}</strong>',
      },
      password: {
        reset: {
          title: '¡Ups! ¿Olvidaste tu contraseña?',
          content:
            '¡No hay problema! Ingresa la dirección de correo electrónico asociada a tu cuenta de cliente. Te enviaremos un enlace para restablecerla.',
          button: 'Restablecer la contraseña',
          sent: {
            success:
              'Te hemos enviado un correo electrónico a <strong>{email}</strong>.',
          },
        },
        restore: {
          title: 'Crear nueva contraseña',
          createPassword: 'Crear contraseña',
          changePassword: 'Cambiar contraseña',
        },
        minLength: 'Al menos 8 caracteres',
        hide: 'ocultar',
        show: 'mostrar',
        capsLockWarning: '¡Bloqueo de mayúsculas activado!',
      },
    },
    addToCart: 'Añadir a la cesta',
    newsletter: {
      subscribe: 'Suscríbete',
      alreadySubscribedTitle: 'Ya se ha suscrito a nuestro boletín de noticias',
      successMailSentTitle: 'Confirme su inscripción',
      alreadySubscribed:
        'Su dirección de correo electrónico está en nuestra lista de distribución y pronto tendrá noticias nuestras.',
      successMailSent:
        'Acabamos de enviarle un correo electrónico. Ábralo y confirme su inscripción a través del enlace.',
      noteSpam:
        'Compruebe también su carpeta de correo no deseado si no encuentra el mensaje.',
    },
    customerSatisfaction: {
      title: 'Valórenos',
      description:
        '¿Está satisfecho con su experiencia de compra en nuestra tienda en línea?',
      feedbackPlaceholder: 'Por favor, danos tu opinión sobre tu compra.',
      privacyPolicy:
        'Aquí puede leer nuestra <a class="text-primary" target="_blank" href="{link}">política de privacidad</a>.',
      submit: 'Enviar valoración',
      pleaseProvideRating: 'Por favor selecciona un emoji',
      submittedTitle: '¡Gracias!',
      submittedText:
        '¡Gracias por tomarse el tiempo de enviarnos sus comentarios para que podamos mejorar aún más nuestra tienda en línea con su ayuda! Estaremos encantados de que compartas tus experiencias públicamente en Google con otros usuarios: <a class="text-primary" target="_blank" href="{link}">Califica ahora públicamente en Google</a>.',
      googleRatingUrl: 'http://bit.ly/satch-google-bewertung',
    },
    cart: {
      article: 'Artículo',
      title: 'Cesta',
      articleAdded: 'Artículo añadido',
      articleAddedLong: 'Añadir artículo a la cesta',
      style: 'Estilo',
      toCart: 'A la cesta de la compra',
      cartItems: {
        promotionalInfo: 'Nota para la campaña de descuentos',
        attributes: {
          size: 'Talla',
          style: 'Estilo',
          value: 'Valor',
          quantity: 'Cantidad',
        },
      },
      discover_now: 'Descubre ahora',
      to_product: 'Al producto',
      email: 'Correo electrónico',
      password: 'Contraseña',
      urls: {
        privatePolicy: 'privacy-policy',
      },
    },
    validation: {
      formErrors: 'El formulario contiene errores',
      addToCart: 'Se ha producido un error al añadir el producto',
      requiredField: 'Campo obligatorio',
      error: {
        requiredField: 'Rellene el campo obligatorio.',
      },
    },
    product: {
      addToCart: 'añada',
      addToCartAtWishlist: 'Carrito',
      atCart: 'En el carrito',
      comingSoon: 'muy pronto',
      availableAt: 'disponible de',
      availableAgainAt: 'disponible nuevamente desde',
      soldOut: 'agotado',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Cupón',
    },
    navigation: {
      customer_menu: {
        logout: {
          my_account: 'Mi cuenta',
          my_orders: 'Mis pedidos',
          logout: 'Cierre de sesión',
          backToShop: 'Volver a la tienda',
        },
        login: {
          header: 'Inicie sesión aquí en satch.',
          content:
            'Introduzca su dirección de correo electrónico y le enviaremos su enlace de acceso:',
          button: 'Solicitar enlace de acceso',
          footer: '¿Eres nuevo?',
          register: 'Iniciar sesión',
          privacy: 'la política de privacidad',
          info: [
            'Al pulsar el botón, doy mi consentimiento para el tratamiento de mis datos de acuerdo con',
            '.',
          ],
        },
        loginSuccess: {
          header: 'Su correo electrónico está en camino.',
          content: [
            'Te hemos enviado el correo electrónico a',
            '. Comprueba la bandeja de entrada de tu correo electrónico y haz clic en el enlace para iniciar sesión. Comprueba también tu carpeta de correo no deseado.',
            '¿No recibes un correo electrónico? Entonces no hay ninguna cuenta con nosotros bajo este correo electrónico. Puede registrarse',
          ],
          register: 'regístrese ahora',
        },
        registerSuccess: {
          header: 'Su correo electrónico está en camino.',
          content: [
            'Le hemos enviado el correo electrónico a',
            '. Compruebe la bandeja de entrada de su correo electrónico y complete el registro utilizando el enlace del correo.',
          ],
        },
        validation: {
          email: {
            required:
              'El correo electrónico debe contener una dirección válida',
          },
        },
        register: {
          header: 'Forme parte de la comunidad satch.',
          content: [
            'Afíliese y asegúrese sus ventajas:',
            'Introduzca su dirección de correo electrónico y le enviaremos un enlace para registrarse:',
          ],
          list: [
            'Resumen de sus pedidos',
            'Vea siempre directamente en qué estado se encuentra su pedido',
            'Crear devolución o reclamación directamente desde su pedido',
          ],
          info: [
            'Al pulsar el botón, doy mi consentimiento al tratamiento de mis datos para crear una cuenta de cliente de acuerdo con la',
            '.',
          ],
          privacy: 'Política de privacidad',
          button: 'Regístrese ahora',
          footer: '¿Tienes una cuenta?',
          login: 'Regístrese aquí',
        },
        registerConfirm: {
          header: 'Hola {name}',
          content: [
            'Ya casi ha llegado. Para completar el registro debes aceptar nuestra política de privacidad.',
          ],
          privacy: ['He tomado nota de la', '.'],
          newsletter: {
            title: 'Suscribirse al boletín de noticias',
            content:
              'Acepto que FOND OF GmbH me informe sobre las promociones, noticias de productos, así como las tendencias actuales de sus marcas por correo electrónico, y me permite valorar los productos.',
            more: 'más',
            moreContent: [
              'Aseguro que tengo al menos 16 años. Es posible revocar o darse de baja del boletín en cualquier momento a través de un enlace en el boletín o mediante un mensaje a',
              '. Tenga en cuenta también nuestra',
            ],
            less: 'menos',
            policy: 'Política de privacidad',
            submit: 'Registro completo',
            cancel: 'Cancelar el registro',
          },
        },
        registerConfirmSuccess: {
          header: 'Enlace de inicio de sesión enviado',
          content: [
            'Le hemos enviado un correo electrónico a ',
            '. Compruebe la bandeja de entrada de su correo electrónico para iniciar sesión en la cuenta de cliente. Comprueba también tu carpeta de correo no deseado.',
          ],
          button: 'Despejado',
        },
        customerAccount: 'Cuenta cliente',
      },
      defaultErrorMessage: 'Algo salió mal',
      search: 'Búsqueda',
    },
    apply: 'Aplicar',
    next: 'Siguiente',
    more: 'más',
    less: 'menos',
    apparel: 'Ropa',
    book: 'Libro',
    kletties: 'Kletties',
    koffer: 'Equipaje',
    furniture: 'Muebles',
    move: 'Vehículo',
    backpack: 'Mochila',
    shoes: 'Zapato',
    accessories: 'Accesorios',
    voucher: 'vale',
    video: {
      playVideo: 'Reproduce el video',
      pauseVideo: 'Pause video',
      play: 'Play',
      pause: 'Pausar',
    },
    productDetail: {
      zoomHint: 'Toca dos veces para hacer zoom',
      imageHint:
        'Las imágenes del producto pueden variar con respecto al original',
    },
    linkTags: '/es/accesorios/tags',
    filter: {
      DEFAULT: 'Filtrar',
      title: 'Filtrar',
      'price-DEFAULT-EUR-GROSS_MODE': 'Precio',
      edition: 'Edición especial',
      resetAll: 'Restablecer todo',
    },
    wishlist: {
      wishlist: 'Lista de deseos',
      myWishlist: 'Mi lista de deseos',
      addProduct: 'El producto ha sido añadido a la lista de deseos',
      deleteProduct: 'El producto ha sido eliminado de tu lista de deseos',
      noItems:
        'Aún queda mucho espacio para su estilo y sus deseos. Inspírate en nuestra gama y llena tu lista de deseos con tus productos favoritos.',
      loginRequired:
        '[Inicia sesión o crea una cuenta de cliente]({link}) para usar la lista de deseos.',
      defaultErrorMessage: 'Algo salió mal',
    },
  },
  da: {
    footer: {
      aBrandOf: 'Et brand af',
      contact: 'Kontakt',
      socialTitle: 'Bliv vores ven',
      languageTitle: 'Sprogs',
      countriesTitle: 'Lande',
      awardsTitle: 'Prisvindende',
      shippingTitle: 'Forsendelse',
      paymentTitle: 'Betalinger',
    },
    contactSlug: 'service?section=contact',
    return: {
      ownCostInfo:
        'Returneringer uden for Tyskland, Schweiz og Italien er for egen regning.',
      createReturn: 'Opret returlabel',
      registerReturn: 'Registrer returnering',
      selectAddress: 'Vælg afsenderadresse',
      qrCode: {
        title: 'DHL Return',
        subHeadline: 'Scan QR-koden i en DHL-butik eller på en pakkestation',
        availableUntil: 'QR-koden er gyldig indtil {date}',
        saveButton: 'Download QR-kode',
        downloadButton: 'Download returlabel',
      },
      batteryHint: {
        headline: 'Produkter med batteri',
        description:
          'Jeg bekræfter, at batterierne er ubeskadigede og usynlige.',
        item1:
          'Der er ingen synlige skader som f.eks. revner, hævelser eller anløbninger.',
        item2: 'Batterierne er ikke mærkbart opvarmede, når de er slukket.',
        importantHint: 'Vigtig bemærkning',
        batteryDamage:
          'Hvis batterierne er beskadigede, skal du ikke returnere produktet til os, men kontakte vores Customer Happiness Team for at aftale nærmere.',
        contactCH: 'Kontakt vores Customer Happiness Team',
      },
      packagingHint: {
        headline: 'Emballageinstruktioner',
        description:
          'Returner venligst produktet i den originale kasse med batteriets advarselsmærkat.',
      },
      nextSteps: {
        headline: 'Næste skridt',
        item1: 'Send os din returnering inden for 30 dage',
        item2:
          'Når vi har modtaget din pakke, kan det tage op til en uge at behandle din returnering.',
        item3:
          'Vi refunderer beløbet til dig ved hjælp af den samme betalingsmetode, som du brugte til din ordre.',
      },
    },
    noMessageReceived: {
      title: 'Har du ikke modtaget nogen besked?',
      content: [
        'Tjek din spam-mappe',
        'Tjek din e-mail-adresse',
        'Prøv igen senere',
      ],
    },
    auth: {
      for: 'login til',
      crossLoginHint: 'de samme loginoplysninger gælder for hvert mærke-konto.',
      blocked: {
        title: 'Tag en pause',
        content:
          'Din konto er i øjeblikket blokeret. Vent {minutes} minutter for at logge ind igen.',
        backToLogin: 'Tilbage til login',
      },
      login: {
        title: 'Log ind',
        loginAttemptsRemaining:
          '<strong>{loginAttemptsRemaining} forsøg tilbage</strong> før din konto midlertidigt låses',
        validation: {
          loginFailed: 'E-mail eller adgangskode er forkert. Prøv igen.',
        },
      },
      register: {
        title: 'Registrer',
        highlights: {
          list: [
            'Loginoplysningerne gælder for hver mærke-konto',
            'Oversigt over dine ordrer',
            'Gratis returnering til Tyskland og Schweiz',
          ],
        },
        privatePolicy: {
          link: '/da/privacy-policy',
          checkbox: [
            'Jeg har læst',
            'privatlivspolitikken',
            '(obligatorisk felt)',
          ],
        },
        newsletter: {
          checkbox: 'Tilmeld dig nyhedsbrevet.',
          info: [
            'Jeg accepterer, at FOND OF GmbH informerer mig om kampagner og konkurrencer, produkt nyheder samt aktuelle trends fra deres mærker via e-mail og',
            'giver mig mulighed for at vurdere produkter.',
            'Jeg garanterer, at jeg er mindst 16 år gammel. En tilbagetrækning eller afmelding af nyhedsbrevet er altid mulig via et link i nyhedsbrevet eller via en besked til',
            'Bemærk også vores',
          ],
        },
        alreadyRegistered: {
          alert:
            'Der findes allerede en konto med vores mærker. Log ind med de samme loginoplysninger eller brug en anden e-mail-adresse.',
          toLogin: 'Log ind med e-mail-adresse',
          forgotPassword: 'Glemt adgangskode',
        },
      },
      migration: {
        enterEmail: 'Indtast din e-mail-adresse:',
        entryOrToRegistration:
          'Tjek din indtastning eller gå til registrering.',
        toRegistration: 'For at registrere',
        new: 'Fra nu af med adgangskode. Vi har sendt dig en e-mail til at oprette en adgangskode. <br /> <br /> Se i din indbakke: <strong>{email}</strong>',
      },
      password: {
        reset: {
          title: 'Ups! Glemt adgangskode',
          content:
            'Intet problem! Indtast den e-mail-adresse, der er tilknyttet din kundekonto. Vi sender dig et link til nulstilling.',
          button: 'Nulstil adgangskode',
          sent: {
            success: 'Vi har sendt dig en e-mail til <strong>{email}</strong>.',
          },
        },
        restore: {
          title: 'Opret ny adgangskode',
          createPassword: 'Opret adgangskode',
          changePassword: 'Skift adgangskode',
        },
        minLength: 'Mindst 8 tegn',
        hide: 'skjul',
        show: 'vis',
        capsLockWarning: 'Caps Lock er aktiveret!',
      },
    },
    addToCart: 'Læg i kurv',
    newsletter: {
      subscribe: 'Tilmeld dig',
      alreadySubscribedTitle: 'Du har allerede tilmeldt dig vores nyhedsbrev',
      successMailSentTitle: 'Bekræft venligst din registrering',
      alreadySubscribed:
        'Din e-mailadresse er på vores mailingliste, og du vil snart høre fra os!',
      successMailSent:
        'Vi har netop sendt dig en e-mail - åbn den og bekræft din tilmelding via linket.',
      noteSpam: 'Tjek også din spam-mappe, hvis du ikke kan finde en e-mail.',
    },
    customerSatisfaction: {
      title: 'Bedøm os!',
      description:
        'Hvor tilfreds er du med indkøbsoplevelsen i vores online shop?',
      feedbackPlaceholder: 'Giv os gerne yderligere feedback på dit køb.',
      privacyPolicy:
        'Her kan du læse vores <a class="text-primary" target="_blank" href="{link}">privatlivspolitik</a>.',
      submit: 'Indsend bedømmelse',
      pleaseProvideRating: 'Vælg venligst en emoji',
      submittedTitle: 'Tak skal du have!',
      submittedText:
        'Tak fordi du tog dig tid til at give os feedback, så vi kan forbedre vores online shop yderligere med din hjælp! Vi ville blive glade, hvis du delte dine oplevelser offentligt på Google med andre brugere: <a class="text-primary" target="_blank" href="{link}">Vurder nu offentligt på Google</a>.',
      googleRatingUrl: 'http://bit.ly/satch-google-bewertung',
    },
    cart: {
      article: 'Artikel',
      title: 'Kurv',
      articleAdded: 'Artikel tilføjet',
      articleAddedLong: 'Artikel tilføjet i kurv',
      style: 'Stil',
      toCart: 'Til varekurven',
      cartItems: {
        promotionalInfo: 'Note til rabatkampagne',
        attributes: {
          size: 'Størrelse',
          style: 'Stil',
          value: 'Værdi',
          quantity: 'Antal',
        },
      },
    },
    discover_now: 'Opdag nu',
    to_product: 'Til produkt',
    apply: 'Anvend',
    next: 'Næste',
    more: 'mere',
    less: 'mindre',
    email: 'E-mail',
    password: 'Adgangskode',
    urls: {
      privatePolicy: 'privacy-policy',
    },
    validation: {
      formErrors: 'Formularen indeholder fejl',
      addToCart: 'Der opstod en fejl under tilføjelsen af produktet',
      requiredField: 'Obligatorisk felt',
      error: {
        requiredField: 'Udfyld venligst det obligatoriske felt.',
      },
    },
    product: {
      addToCart: 'Tilføj',
      addToCartAtWishlist: 'Kurv',
      atCart: 'I kurven',
      comingSoon: 'kommer snart',
      availableAt: 'ledig fra',
      availableAgainAt: 'tilgængelig igen fra',
      soldOut: 'udsolgt',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Kupon',
    },
    navigation: {
      customer_menu: {
        logout: {
          my_account: 'Min konto',
          my_orders: 'Mine bestillinger',
          logout: 'Logout',
          backToShop: 'Tilbage til butik',
        },
        login: {
          header: 'Log ind her på satch.',
          content:
            'Indtast din e-mailadresse, så sender vi dig dit login-link:',
          button: 'Anmodning om login-link',
          footer: 'Er du ny her?',
          register: 'Log ind nu',
          privacy: 'privatlivspolitikken',
          info: [
            'Ved at klikke på knappen giver jeg samtykke til behandling af mine data i overensstemmelse med',
            '.',
          ],
        },
        loginSuccess: {
          header: 'Din e-mail er på vej til dig.',
          content: [
            'Vi har sendt dig en e-mail til',
            '. Tjek din indbakke, og klik på linket for at logge ind. Tjek også din spam-mappe.',
            'Har du ikke fået en e-mail? Så er der ingen konto hos os under denne e-mail. Du kan registrere dig',
          ],
          register: 'tilmeld dig her nu',
        },
        registerSuccess: {
          header: 'Din e-mail er på vej til dig.',
          content: [
            'Vi har sendt dig en e-mail til',
            '. Tjek din indbakke, og gennemfør registreringen ved hjælp af linket i e-mailen.',
          ],
        },
        validation: {
          email: {
            required: 'E-mailen skal indeholde en gyldig e-mailadresse',
          },
        },
        register: {
          header: 'Bliv en del af satch-fællesskabet.',
          content: [
            'Bliv medlem og sikr dig dine fordele:',
            'Indtast din e-mailadresse, så sender vi dig et link til at registrere dig:',
          ],
          list: [
            'Oversigt over dine ordrer',
            'Du kan altid se direkte, hvilken status din ordre har',
            'Opret returnering eller reklamation direkte fra din ordre',
          ],
          info: [
            'Ved at trykke på knappen giver jeg samtykke til behandling af mine oplysninger med henblik på oprettelse af en kundekonto i overensstemmelse med',
            '.',
          ],
          privacy: 'Databeskyttelseserklæring',
          button: 'Tilmeld dig nu',
          footer: 'Har du en konto?',
          login: 'Log ind her',
        },
        registerConfirm: {
          header: 'Hej {name}',
          content: [
            'Du er der næsten. For at gennemføre registreringen skal du acceptere vores privatlivspolitik.',
          ],
          privacy: ['Jeg har noteret mig den', '.'],
          newsletter: {
            title: 'Tilmeld dig nyhedsbrevet',
            content:
              'Jeg accepterer, at FOND OF GmbH informerer mig om kampagner, produktnyheder samt aktuelle tendenser for deres mærker via e-mail og giver mig mulighed for at bedømme produkter.',
            more: 'mere',
            moreContent: [
              'Jeg forsikrer, at jeg er mindst 16 år gammel. En tilbagekaldelse eller afmelding fra nyhedsbrevet er til enhver tid mulig via et link i nyhedsbrevet eller via en besked til',
              '. Vær også opmærksom på vores',
            ],
            less: 'mindre',
            policy: 'Databeskyttelseserklæring',
            submit: 'Fuldføre registreringen',
            cancel: 'Annuller registrering',
          },
        },
        registerConfirmSuccess: {
          header: 'Login link sendt',
          content: [
            'Vi har sendt dig en e-mail til ',
            '. Tjek din e-mailindbakke for at logge ind på kundekontoen. Tjek også din spam-mappe.',
          ],
          button: 'Alt er klart',
        },
        customerAccount: 'Kundekonto',
      },
      defaultErrorMessage: 'Noget gik galt',
      search: 'Søg',
    },
    apparel: 'Beklædning',
    book: 'Bog',
    kletties: 'Kletties',
    koffer: 'Valigie',
    furniture: 'Møbler',
    move: 'Køretøjer',
    backpack: 'Rygsæk',
    shoes: 'Sko',
    accessories: 'Tilbehør',
    voucher: 'Kuponer',
    video: {
      playVideo: 'Play video',
      pauseVideo: 'Pause video',
      play: 'Play',
      pause: 'Pause',
    },
    productDetail: {
      zoomHint: 'Dobbelttryk for at zoome',
      imageHint: "Le immagini dei prodotti possono differire dall'originale",
    },
    linkTags: '/dk/tilbehor/tags',
    filter: {
      DEFAULT: 'Filtrer',
      title: 'Filtrer',
      'price-DEFAULT-EUR-GROSS_MODE': 'Pris',
      edition: 'Special Edition',
      resetAll: 'Nulstil alle',
    },
    wishlist: {
      wishlist: 'Ønskeliste',
      myWishlist: 'Min ønskeliste',
      addProduct: 'Produktet er blevet tilføjet til ønskelisten',
      deleteProduct: 'Produktet er blevet fjernet fra din ønskeliste',
      noItems:
        'Der er stadig masser af plads til din stil og dine ønsker! Lad dig inspirere af vores sortiment, og fyld din ønskeliste med dine yndlingsprodukter.',
      loginRequired:
        '[Log ind eller opret en kundekonto]({link}) for at bruge ønskelisten.',
      defaultErrorMessage: 'Noget gik galt',
    },
  },
  fr: {
    footer: {
      aBrandOf: 'Une marque de',
      contact: 'Contact',
      socialTitle: 'Deviens notre ami',
      languageTitle: 'Langues',
      countriesTitle: 'Pays',
      awardsTitle: 'Excellent',
      shippingTitle: 'Expédition',
      paymentTitle: 'Paiement',
    },
    contactSlug: 'service?section=contact',
    return: {
      ownCostInfo:
        "Les retours en dehors de l'Allemagne, de la Suisse et de l'Italie sont à votre charge.",
      createReturn: 'Créer une étiquette de retour',
      registerReturn: 'Enregistrer le retour',
      selectAddress: "Sélectionner l'adresse de retour",
      qrCode: {
        title: 'Retours DHL',
        subHeadline:
          "Scanne le code QR dans un magasin DHL ou une station d'emballage.",
        availableUntil: "Code QR valable jusqu'à {date}",
        saveButton: 'Télécharger le code QR',
        downloadButton: "Télécharger l'étiquette de retour",
      },
      batteryHint: {
        headline: 'Produits avec batterie',
        description:
          "Je confirme que les piles ne sont pas endommagées et qu'elles ne sont pas visibles.",
        item1:
          "Il n'y a pas de dommages visibles tels que des fissures, des gonflements ou des points de démarrage.",
        item2:
          "Lorsque les piles sont éteintes, leur échauffement n'est pas perceptible.",
        importantHint: 'Remarque importante',
        batteryDamage:
          'Si les piles sont endommagées, ne nous renvoie pas le produit, mais contacte notre équipe Customer Happiness pour connaître la marche à suivre.',
        contactCH: "Contacter l'équipe Customer Happiness",
      },
      packagingHint: {
        headline: "Remarque sur l'emballage",
        description:
          "Veuillez retourner le produit dans son carton d'origine avec l'avertissement relatif aux piles.",
      },
      nextSteps: {
        headline: 'Prochaines étapes',
        item1: 'Envoie-nous ton retour dans les 30 jours.',
        item2:
          "Une fois que ton colis nous est parvenu, le traitement du retour peut prendre jusqu'à une semaine.",
        item3:
          'Nous te remboursons en utilisant le même mode de paiement que celui que tu as utilisé pour ta commande.',
      },
    },
    noMessageReceived: {
      title: "Vous n'avez pas reçu de message?",
      content: [
        'Vérifiez votre dossier spam',
        'Vérifiez votre adresse e-mail',
        'Réessayez plus tard',
      ],
    },
    auth: {
      for: 'connexion à',
      crossLoginHint:
        'les mêmes informations de connexion sont valables pour chaque compte de marque.',
      blocked: {
        title: 'Faites une pause',
        content:
          'Votre compte est actuellement bloqué. Veuillez attendre {minutes} minutes pour vous reconnecter.',
        backToLogin: 'Retour à la connexion',
      },
      migration: {
        enterEmail: 'Entrez votre adresse e-mail:',
        entryOrToRegistration:
          "Vérifiez votre entrée ou passez à l'enregistrement.",
        toRegistration: 'Pour vous inscrire',
        new: 'Désormais avec mot de passe. Nous vous avons envoyé un e-mail pour créer un mot de passe. <br /> <br /> Regardez dans votre boîte de réception: <strong>{email}</strong>',
      },
      password: {
        minLength: 'Au moins 8 caractères',
        reset: {
          title: 'Oops! Mot de passe oublié',
          content:
            "Pas de problème! Veuillez saisir l'adresse e-mail associée à votre compte client. Nous vous enverrons un lien pour le réinitialiser.",
          button: 'Réinitialiser le mot de passe',
          sent: {
            success:
              'Nous vous avons envoyé un e-mail à <strong>{email}</strong>.',
          },
        },
        hide: 'cacher',
        show: 'montrer',
        capsLockWarning: 'Le verrouillage des majuscules est activé!',
        restore: {
          title: 'Créer un nouveau mot de passe',
          createPassword: 'Créer un mot de passe',
          changePassword: 'Changer le mot de passe',
        },
      },
      login: {
        title: 'connexion',
        loginAttemptsRemaining:
          '<strong>{loginAttemptsRemaining} tentatives</strong> avant que votre compte ne soit temporairement verrouillé',
        validation: {
          loginFailed:
            "L'e-mail ou le mot de passe est incorrect. Veuillez réessayer.",
        },
      },
      register: {
        title: 'enregistrement',
        highlights: {
          list: [
            'Les informations de connexion sont valables pour chaque compte de marque',
            'Aperçu facile des commandes',
            "Retours gratuits pour l'Allemagne et la Suisse",
          ],
        },
        privatePolicy: {
          link: '/fr/privacy-policy',
          checkbox: [
            "J'ai lu la",
            'politique de confidentialité',
            '(champ obligatoire)',
          ],
        },
        newsletter: {
          checkbox: "S'abonner à la newsletter.",
          info: [
            "J'accepte que FOND OF GmbH m'informe des promotions et concours, des actualités produits ainsi que des tendances actuelles de leurs marques par e-mail et me permette d'évaluer les produits.",
            "Je garantis que j'ai au moins 16 ans. Une révocation ou une désinscription de la newsletter est possible à tout moment via un lien dans la newsletter ou via un message à",
            'Veuillez également prendre note de notre',
            'politique de confidentialité',
          ],
        },
        alreadyRegistered: {
          alert:
            'Un compte existe déjà pour nos marques. Veuillez vous connecter avec les mêmes identifiants ou utiliser une autre adresse e-mail.',
          toLogin: "Se connecter avec l'adresse e-mail",
          forgotPassword: 'Mot de passe oublié',
        },
      },
    },
    addToCart: 'Ajouter au panier',
    newsletter: {
      subscribe: 'Accedi',
      alreadySubscribedTitle: 'Tu es déjà abonné à notre newsletter',
      successMailSentTitle: 'Confirme ton inscription',
      alreadySubscribed:
        'Ton adresse e-mail est enregistrée dans notre liste de diffusion et tu auras bientôt de nos nouvelles !',
      successMailSent:
        "Nous venons de t'envoyer un e-mail - merci de l'ouvrir et de confirmer ton inscription en cliquant sur le lien.",
      noteSpam:
        "Vérifie également le dossier spam si tu ne trouves pas d'e-mail.",
    },
    customerSatisfaction: {
      title: 'Donne-nous une note!',
      description:
        "Es-tu satisfait de ton expérience d'achat dans notre boutique en ligne?",
      feedbackPlaceholder: "N'hésite pas à nous donner ton avis sur ton achat.",
      privacyPolicy:
        'Tu peux lire ici notre <a class="text-primary" target="_blank" href="{link}">déclaration de confidentialité</a>.',
      submit: 'Envoyer',
      pleaseProvideRating: 'Veuillez choisir un emoji',
      submittedTitle: 'Merci beaucoup!',
      submittedText:
        'Merci d\'avoir pris le temps de nous faire part de vos commentaires afin que nous puissions encore améliorer notre boutique en ligne avec votre aide! Nous serions heureux si vous partagiez publiquement vos expériences sur Google avec d\'autres utilisateurs: <a class="text-primary" target="_blank" href="{link}">Notez maintenant publiquement sur Google</a>.',
      googleRatingUrl: 'https://bit.ly/satch-google-bewertung',
    },
    cart: {
      title: 'Mon panier',
      article: 'Article',
      empty: 'Votre panier est vide',
      articleAdded: 'Article ajouté',
      articleAddedLong: 'Article ajouté au panier',
      style: 'Style',
      toCart: 'Dans le panier',
      cartItems: {
        promotionalInfo: "Note pour l'action de réduction",
        attributes: {
          size: 'Taille',
          style: 'Style',
          value: 'Valeur',
          quantity: 'Quantité',
        },
      },
    },
    apply: 'Appliquer',
    next: 'Suivant',
    more: 'plus',
    less: 'moins',
    new: 'Nouveau',
    discover_now: 'A découvrir',
    to_product: 'Au produit',
    email: 'Courriel',
    password: 'Mot de passe',
    close: 'fermer',
    back: 'retour',
    show_less: 'afficher moins',
    urls: {
      privatePolicy: 'privacy-policy',
    },
    validation: {
      formErrors: 'Le formulaire contient des erreurs',
      addToCart: "Une erreur s'est produite lors de l'ajout du produit",
      requiredField: 'Champ obligatoire',
      error: {
        requiredField: 'Veuillez remplir le champ obligatoire.',
      },
    },
    product: {
      addToCart: 'Ajouter au panier',
      addToCartAtWishlist: 'Panier',
      atCart: 'Dans le panier',
      comingSoon: 'coming soon',
      availableAt: 'disponible le',
      availableAgainAt: 'disponible le',
      soldOut: 'sold out',
      new: 'new',
      sale: 'sale',
      free: 'free',
      voucher: 'Bon',
    },
    navigation: {
      customer_menu: {
        logout: {
          my_account: 'Mon compte',
          my_orders: 'Mes commandes',
          logout: 'Déconnexion',
          backToShop: 'Retour à la boutique',
        },
        login: {
          header: 'Se connecter ici à satch.',
          content:
            'Saisissez votre adresse e-mail et nous vous enverrons votre lien de connexion :',
          button: 'Demander le lien de connexion',
          footer: 'Nouveau ici ?',
          register: "S'inscrire",
          privacy: 'politique de confidentialité',
          info: [
            'En appuyant sur le bouton, je consens au traitement de mes données conformément à la',
            '.',
          ],
        },
        loginSuccess: {
          header: "Votre courriel est en cours d'acheminement.",
          content: [
            "Nous vous avons envoyé l'email à",
            '. Vérifiez votre boîte de réception et cliquez sur le lien pour vous connecter. Vérifiez également votre dossier spam.',
            "Vous ne recevez pas d'e-mail ? Dans ce cas, il n'y a pas de compte chez nous sous cet email. Vous pouvez vous inscrire",
          ],
          register: "s'inscrire ici",
        },
        registerSuccess: {
          header: "Votre courriel est en cours d'acheminement.",
          content: [
            "Nous vous avons envoyé l'email à",
            ". Vérifiez votre boîte de réception et complétez l'inscription en utilisant le lien contenu dans l'e-mail.",
          ],
        },
        validation: {
          email: {
            required: "L'email doit contenir une adresse email valide",
          },
        },
        register: {
          header: 'Faites partie de la communauté satch.',
          content: [
            'Devenez membre et assurez vos avantages :',
            'Saisissez votre adresse électronique et nous vous enverrons un lien pour vous inscrire :',
          ],
          list: [
            'Aperçu de vos commandes',
            "Vous pouvez toujours voir directement l'état d'avancement de votre commande",
            'Créez un retour ou une réclamation directement à partir de votre commande',
          ],
          info: [
            "En appuyant sur le bouton, je consens au traitement de mes données pour la création d'un compte client conformément à la",
            '.',
          ],
          privacy: 'Politique de confidentialité',
          button: "S'inscrire",
          footer: 'Vous avez un compte ?',
          login: 'Connectez-vous ici',
        },
        registerConfirm: {
          header: 'Bonjour {name}',
          content: [
            "Vous y êtes presque. Pour terminer l'enregistrement, vous devez accepter notre politique de confidentialité.",
          ],
          privacy: ["J'ai pris note de la", '.'],
          newsletter: {
            title: "S'abonner à la lettre d'information",
            content: "J'accepte que FOND OF GmbH m'informe des promotions.",
            more: 'plus',
            moreContent: [
              "Je garantis que j'ai au moins 16 ans. Une révocation ou une désinscription de la lettre d'information est possible à tout moment via un lien dans la lettre d'information ou via un message à l'adresse suivante",
              '. Veuillez également noter que notre',
            ],
            less: 'moins',
            policy: 'Politique de confidentialité',
            submit: 'Inscription complète',
            cancel: "Annuler l'inscription",
          },
        },
        registerConfirmSuccess: {
          header: 'Votre inscription a été effectuée avec succès.',
          content: [
            'Nous vous avons envoyé un courriel à',
            '. Vérifiez votre boîte aux lettres électronique pour vous connecter au compte client. Vérifiez également votre dossier de courrier indésirable.',
          ],
          button: 'Très bien',
        },
        customerAccount: 'Compte client',
      },
      defaultErrorMessage: "Quelque chose n'a pas fonctionné",
      search: 'Recherche',
    },
    filter: {
      DEFAULT: 'Filtre',
      title: 'Filtrer',
      'price-DEFAULT-EUR-GROSS_MODE': 'Prix',
      edition: 'Special Edition',
      resetAll: 'Réinitialiser tout',
    },
    price: {
      DEFAULT: 'Prix',
    },
    price_asc: 'Prix croissant',
    price_desc: 'Prix décroissant',
    noResults: "Aucun résultat n'a été trouvé",
    apparel: 'Vêtements',
    book: 'Livre',
    kletties: 'Kletties',
    koffer: 'Bagage',
    furniture: 'Meubles',
    move: 'Voiture',
    backpack: 'Sac à dos',
    shoes: 'Chaussure',
    accessories: 'Accessories',
    voucher: 'Bon',
    wishlist: {
      wishlist: 'Liste de souhaits',
      myWishlist: 'Ma liste de souhaits',
      addProduct: 'Le produit a été ajouté à la liste de souhaits',
      deleteProduct: 'Le produit a été supprimé de votre liste de souhaits',
      noItems:
        'Il y a encore beaucoup de place pour ton style et tes envies ! Laisse-toi inspirer par notre assortiment et remplis ta liste de souhaits avec tes produits préférés.',
      loginRequired:
        '[Connectez-vous ou créez un compte client]({link}) pour utiliser la liste de souhaits.',
      defaultErrorMessage: 'Quelque chose a mal tourné',
    },
  },
}
export const t = (term: string, props: Record<string, string> = {}) =>
  translate(translations, term, props)
